/* eslint react-hooks/rules-of-hooks: "error", react-hooks/exhaustive-deps: "error" */
import { useMemo } from "react";

import { IContext, useFilters } from "../../../../context/filters";
import { getSortedFilters } from "../helpers";

export const useSortedFilters = (): Required<IContext> => {
  const { entityFilters, loading } = useFilters();
  const sortedFilters = useMemo(() => getSortedFilters(entityFilters || []), [entityFilters]);
  return {
    entityFilters: sortedFilters,
    loading
  };
};
